import { FC } from 'react';
import { FlexBox, Tooltip } from '@brg/ui';
import { ProjectTooltipProps } from '../tooltips/ProjectTooltip';
import { ProjectEvents } from '../../helpers/projectEvents';
import styled from 'styled-components';
import { LayoutConst } from 'core';
import { SubscribeTooltip } from '../tooltips/SubscribeTooltip';
import { ReactComponent as MoreCircleSvg } from 'shared/components/projectCard/assets/more-circle.svg';

export const BackdropContainer = styled(FlexBox)`
  justify-content: center;
  place-items: center;
  background: rgba(24, 26, 28, 0.5);
  backdrop-filter: blur(2px);
  border-radius: 50%;
  height: 32px;
  width: 32px;
  min-width: 32px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 24px;
    width: 24px;  
    min-width: 24px;
  }
`;

export const SubscribeTools: FC<any> = (props) => (
  <Tooltip zIndex={9999999999} placement={props.placement} target={
    <BackdropContainer>
      <MoreCircleSvg />
    </BackdropContainer>}>
    <SubscribeTooltip {...props} />
  </Tooltip>
);
import { FC } from 'react';
import { FlexBox, Tooltip } from '@brg/ui';
import { ProjectTooltipProps } from '../tooltips/ProjectTooltip';
import { ProjectEvents } from '../../helpers/projectEvents';
import styled from 'styled-components';
import { LayoutConst } from 'core';
import { SubscribeTooltip } from '../tooltips/SubscribeTooltip';
import { ReactComponent as MoreCircleSvg } from 'shared/components/projectCard/assets/more-circle.svg';

export const BackdropContainer = styled(FlexBox)`
  justify-content: center;
  place-items: center;
  background: rgba(24, 26, 28, 0.5);
  backdrop-filter: blur(2px);
  border-radius: 50%;
  height: 32px;
  width: 32px;
  min-width: 32px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 24px;
    width: 24px;  
    min-width: 24px;
  }
`;

export const SubscribeTools: FC<any> = (props) => (
  <Tooltip zIndex={9999999999} placement={props.placement} target={
    <BackdropContainer>
      <MoreCircleSvg />
    </BackdropContainer>}>
    <SubscribeTooltip {...props} />
  </Tooltip>
);
